<template>
    <div>
        <button style="position: relative;" href="#" 
            @mouseover="onHover" 
            @mouseleave="event = ''" 
            @mousedown="onMouseDown"
            @mouseup="event = ''" :class="classes" 
            @click="onClick"><span v-if="icon != 'plus' && icon"><img :src="'/img/icons/btn-'+icon+'.svg'" style="padding: 0px 5px; margin-top: -5px; z-index: 1;  height: 15px;" alt=""></span>{{ text }}
            <img v-if="iconPlus" class="btn-add-icon" src="/img/icons/icon-plus-circle.svg" />
        </button>
    </div>
</template>
<script>
    export default {
        props: ["type", "text", "icon"],
        name: "Button",
        data(){
            return {
                event: ''
            }
        },
        computed: {
            classes(){
                return `t1-btn${this.btnType}${this.btnEventClass}`;
            },
            btnType(){
                return this.type ? ` t1-btn--${this.type}` : '';
            },
            btnEventClass(){
                return this.event ? ` t1-btn--${this.event}` : '';
            },
            iconPlus(){
                return this.icon === "plus" ? true : false;
            }
        },
        methods: {
            onClick(){
                if(this.type != 'disabled'){
                    this.$emit("onClick");
                }
            },
            onHover(){
                if(this.type != 'disabled' && this.type != 'default'){
                    if(this.type === 'primary-admin-ghost' ){
                        this.event = 'ghost-hover';
                    } else if (this.type != 'ghost') {
                        this.event = 'hover';
                    }
                    else {
                        this.event = 'ghost-hover';
                    }
                }
            },
            onMouseDown(){
                if(this.type != 'disabled' && this.type != 'default'){
                    if(this.type === 'primary-admin-ghost'){
                        this.event = 'ghost-hover';
                    }
                    else if (this.type != 'ghost'){
                        this.event = 'focus';
                    }
                    else {
                        this.event = 'ghost-focus';
                    }
                }
            }
        }
    }
</script>
<style>
    .btn-add-icon {
        left: 0;
        position: absolute;
        top: 50%;
        width: 5rem;
        transform: translate(-50%, -50%);
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }
</style>